import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './OccurrenceSKCaddons.html?raw';
// NOTE (JS2TS): dropped dead dojo deps (lang, aspect, on, dom-construct, dom-attr, dom-class, dom-style, number) — none used in code.

class OccurrenceSKCaddons extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    outputData: any = {};

    _undirtyData: any = null;

    _onChangeComment(evt?: any): void {
        this.serializeData();
    }

    setFormData(data: any, bResetDirty?: any): void {
        if (!data) {
            return;
        }
        this.inputComment.value = data.comment;

        this.checkDirty(bResetDirty !== false); // dirty resetten
    }

    serializeData(): void {
        this.outputData = {
            comment: this.inputComment.value
        };

        if (this.checkDirty() == true) {
            this.emit("change", this.outputData);
        }
    }

    checkDirty(bReset?: any): any {
        let currentDataTxt = JSON.stringify(this.outputData);

        if (bReset === true) {
            this._undirtyData = currentDataTxt;
            this.dirty = false;
        }

        if (this._undirtyData != currentDataTxt) {
            this.dirty = true;
        } else {
            this.dirty = false;
        }

        return this.dirty;
    }

    _setValueAttr(data: any): void {
        this.setFormData(data);
    }

    _getValueAttr(): any {
        return this.outputData;
    }

    getValue(): any {
        return this.outputData;
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.outputData = {};
    }

    startup(data?: any): void {
        super.startup.apply(this, arguments as any);

        if (data) {
            this.setFormData(data);
        }
    }

}
OccurrenceSKCaddons.prototype.declaredClass = 'WidgetCollection.JDM.Occurrence.OccurrenceSKCaddons';

export default mdsWidget(OccurrenceSKCaddons);
